module.exports = __webpack_public_path__ + "img/wallpaper8.4852ce5e.png";